import { z } from 'zod';

/** 給与計算体系（賃金形態）フィルタ */
export const WageTypeFilter = z.enum(['all', 'monthly', 'hourly', 'annual']);
export type WageTypeFilter = z.infer<typeof WageTypeFilter>;

/** 賃金台帳一覧の対象年度 */
export const LedgerYear = z.enum(['2025', '2026']);
export type LedgerYear = z.infer<typeof LedgerYear>;
export const LEDGER_YEARS = LedgerYear.options;
export const DEFAULT_LEDGER_YEAR = '2026' satisfies LedgerYear;
export function resolveLedgerYear(year?: LedgerYear): LedgerYear {
  return year ?? DEFAULT_LEDGER_YEAR;
}
export const LedgerSearchSchema = z.object({
  freeText: z.string().default(''),
  pageSize: z.number().default(100),
  pageIndex: z.number().default(0),
  wageType: WageTypeFilter.default('all'),
  ledgerYear: LedgerYear.optional(),
  organizationIn: z.array(z.string()).optional()
});
export type LedgerSearchParams = z.infer<typeof LedgerSearchSchema>;